import { Controller } from '@hotwired/stimulus';
import Swiper, {Pagination, Navigation, EffectFade, FreeMode, Autoplay, Thumbs} from 'swiper';

export default class extends Controller {
    static values = {
        menu: Array,
    }
    connect() {
        Swiper.use([Navigation, Pagination, EffectFade, FreeMode, Autoplay, Thumbs]);

        const thumbsSlider = new Swiper(".thumbs-slider", {
            spaceBetween: 5,
            slidesPerView: "auto",
            freeMode: true,
            watchSlidesProgress: true,
        });

        new Swiper(".main-slider", {
            spaceBetween: 10,
            navigation: {
                nextEl: ".main-slider-swiper-button-next",
                prevEl: ".main-slider-swiper-button-prev",
            },
            thumbs: {
                swiper: thumbsSlider,
            },
        });

    }
}
